import React from 'react'
import ReactDOM from 'react-dom'
import PureRenderMixin from 'react-addons-pure-render-mixin'

import Map from './components/map'
import Programs from './components/programs'

import {dispatch} from 'fluxury'
import {loadPrograms, loadStates, changeSelectedState} from './actions/actions'
import HardestHitStore from './stores/hardest-hit-store'

import programs from '../test/testPrograms'
import states from '../test/testStates'

const baseURI = 'https://hardest-hit.firebaseio.com'

var App = React.createClass({
  mixins: [PureRenderMixin],

  getInitialState: function(){
    return {
      programStates: [],
      programs: [],
      currentState: ''
    }
  },

  componentDidMount() {

    this.storeToken = HardestHitStore.addListener(this.onStoreChange)
  /*
    function loadJSON(action, url) {
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          dispatch(action, JSON.parse(xmlhttp.responseText));
        }
      };
      xmlhttp.open("GET", url, true);
      xmlhttp.send();
    }
    loadJSON(loadPrograms, baseURI + '/programs.json')
    loadJSON(loadStates, baseURI + '/states.json')
    */

    dispatch(loadPrograms, programs);
    dispatch(loadStates, states);


  },

  componentWillUnmount: function() {
    this.storeToken.remove()
  },

  onStoreChange: function(){
    this.setState({
      programStates: HardestHitStore.getStates(),
      programs: HardestHitStore.getPrograms(),
      currentState: HardestHitStore.getSelectedState()
    })
  },

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <Map
              statesList={this.state.programStates}
              programs={this.state.programs}
              currentState={this.state.currentState}
              />
          </div>
          <div className="col-md-6">
            <Programs
              statesList={this.state.programStates}
              programs={this.state.programs}
              currentState={this.state.currentState}
              />
          </div>
        </div>
      </div>
    )
  }
})

ReactDOM.render(<App />,document.getElementById('wrapper'))



// WEBPACK FOOTER //
// ./src/main.js